import _ from 'lodash';

export function resourceMapper(attrs, modelName, sectionName) {

    return attrs.reduce((computedPropertyObject, attr) => {

        var propName, attrName, defaultValue, preprocess;

        if (attr.hasOwnProperty('attributeName')) {
            propName = attr['propertyName'];
            attrName = attr['attributeName'];
            defaultValue = attr['defaultValue'];
            preprocess = attr['preprocess'];

            if (_.isFunction(defaultValue)) {
                defaultValue = defaultValue();
            }

        } else {
            propName = attr;
            attrName = attr;
        }

        const computedProperty = {
            get() {
                if (this[modelName].get(attrName, null) === null) {
                    if (defaultValue !== null && defaultValue !== undefined ) {
                        this[modelName].set(attrName, defaultValue);
                    }
                }
                return this[modelName].get(attrName);
            },
            set(v) {

                if (preprocess) {
                    v = preprocess(v);
                }

                if (this.hasOwnProperty('$v') && this.$v[propName]) {
                    this.$v[propName].$touch();
                }

                if (v !== this[modelName].get(attrName)) {
                    if (v === null) {
                        this[modelName].unset(attrName);
                    } else {
                        this[modelName].set(attrName, v);
                    }

                    if (sectionName) {
                        this.$eventBus.$emit('section-changed', sectionName);
                    }
                }
            }
        };

        computedPropertyObject[propName] = computedProperty;
        return computedPropertyObject;
    }, {});
}
